import React, { useState, useEffect } from "react";
import "../assets/css/hero.css";
import heroImage from "../assets/images/heroimg.png";
import { FaSearch } from "react-icons/fa";
import { supabase } from "../config/supabaseClient";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import img3 from "../assets/images/dear departed.jpg";
import img1 from "../assets/images/10.jpg";
import img2 from "../assets/images/11.jpg";
import img4 from "../assets/images/12.jpg";
import img5 from "../assets/images/mr chips.jpg";
import img6 from "../assets/images/misali9.jpeg";
import img7 from "../assets/images/misali10.jpeg";
import img8 from "../assets/images/misali11.jpeg";
import img9 from "../assets/images/misali12.jpeg";
import img10 from "../assets/images/novel11.jpeg";
import img11 from "../assets/images/position holder.jpeg";
import img12 from "../assets/images/position holder 10.jpeg";
import img13 from "../assets/images/position holder 11.jpeg";
import img14 from "../assets/images/english 10 misali.jpeg";




import { Link } from "react-router-dom";

const Hero = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allWords, setAllWords] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [topics, setTopics] = useState([]);

  const images = [img3, img1, img2, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14];

  // Extract all visible words from the DOM
  const extractTextWordsFromDOM = () => {
    const bodyText = document.body.innerText || "";
    const words = bodyText
      .split(/\s+/)
      .map((w) => w.replace(/[^a-zA-Z]/g, "").toLowerCase())
      .filter((w) => w.length > 2);
    const uniqueWords = [...new Set(words)];
    setAllWords(uniqueWords);
  };

  // Fetch topics from Supabase
  const fetchTopicsFromSupabase = async () => {
    try {
      const { data: topicList, error } = await supabase.from("topics").select("*");
      if (error) throw error;
      setTopics(topicList);
    } catch (err) {
      console.error("Error fetching topics:", err);
    }
  };

  useEffect(() => {
    extractTextWordsFromDOM();
    fetchTopicsFromSupabase();
  }, []);



  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-badge"> Modern Learning Platform</div>
        <h1>
          Master English with <span className="hero-highlight">Confidence</span>
        </h1>
        <h2 className="hero-subheading">
          Learn Grammar, Structure & Writing the Smart Way
        </h2>
        <p className="hero-description">
          <span className="brand-statement">Gramture, a blend of the words Grammar and Structure, symbolizes a modern approach to education.</span>
        </p>

        <div className="hero-feature-chips">
          <span className="feature-chip">Grammar Learning</span>
          <span className="feature-chip">Essay Writing</span>
          <span className="feature-chip">Applications</span>
          <span className="feature-chip">Letters</span>
          <span className="feature-chip">Moral Stories</span>
        </div>

        <div className="hero-cta-group">
          <Link to="/notes/grammar">
            <button className="btn-primary-modern">Start Learning</button>
          </Link>
          <button className="btn-secondary-modern" onClick={() => {
            window.scrollTo({ top: 800, behavior: 'smooth' });
          }}>Explore Topics</button>
        </div>
      </div>

      <div className="hero-image">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          transitionTime={800}
          showStatus={false}
          showArrows
          showIndicators
          stopOnHover
          swipeable
          emulateTouch
        >
          {images.map((img, index) => (
            <div key={index}>
              <img src={img} alt={`Slide ${index}`} className="carousel-img" />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Hero;
